import React from 'react';

import {
  useCurrencyFormat,
  useNumberFormat,
  usePercentFormat,
  useDateFormat,
} from '@gogame/intl-ts';

import { FORMULA } from 'scenes/SmartRules/SmartRuleForm/Conditions';

export const DATE = 'Date';
export const CURRENCY = 'Currency';
export const PERCENT = 'Percent';
export const NUMBER = 'Number';

export const useFormatValue = () => {
  const currencyFormatter = useCurrencyFormat();
  const percentFormatter = usePercentFormat();
  const numberFormatter = useNumberFormat();
  const dateFormat = useDateFormat();

  return React.useCallback((value, type, conditionType) => {
    if (conditionType === FORMULA) {
      return value;
    }

    switch (type) {
      case DATE:
        return dateFormat(value);
      case CURRENCY:
        return currencyFormatter(Number(value));
      case PERCENT:
        return percentFormatter(Number(value));
      case NUMBER:
        return numberFormatter(Number(value));
      default:
        return value;
    }
  }, []);
};
